/** API EquipmentType ↔ UI equipment master fields. */

export function equipmentTypeFromApi(row) {
  if (!row) return null;
  return {
    id: row.id,
    equipmentId: row.code ?? '',
    name: row.name ?? '',
    category: row.category ?? '',
    vehicleClass: row.vehicleClass ?? '',
    description: row.description ?? '',
    active: row.isActive !== false,
    createdAt: row.createdAt ?? null,
    updatedAt: row.updatedAt ?? null,
  };
}

export function equipmentTypeToApi(ui) {
  if (!ui) return null;
  return {
    name: ui.name,
    category: ui.category || null,
    vehicleClass: ui.vehicleClass || null,
    description: ui.description || null,
    isActive: ui.active !== false,
  };
}
